import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, Space, Divider } from 'antd';
import { UserOutlined, LockOutlined, LoginOutlined } from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext';

const { Title, Text } = Typography;

interface LoginFormData {
  username: string;
  password: string;
}

const Login: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  /**
   * Handle form submission
   * @param values - Form data containing username and password
   */
  const onFinish = async (values: LoginFormData) => {
    setLoading(true);
    try {
      // Convert username to lowercase
      const lowercaseUsername = values.username.toLowerCase();
      const success = await login(lowercaseUsername, values.password);
      if (success) {
        // Navigation will be handled by the App component
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <Card className="login-card">
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          {/* Header */}
          <div style={{ textAlign: 'center' }}>
            <Title level={isMobile ? 3 : 2} style={{ margin: 0, color: '#1890ff', fontSize: isMobile ? '20px' : '24px' }}>
              {isMobile ? 'GPhotoPlus' : 'GPhotoPlus Management'}
            </Title>
            <Text type="secondary" style={{ fontSize: isMobile ? '13px' : '14px' }}>Sign in to your account</Text>
          </div>

          <Divider />

          {/* Login Form */}
          <Form
            name="login"
            onFinish={onFinish}
            autoComplete="off"
            layout="vertical"
            size="large"
          >
            <Form.Item
              name="username"
              rules={[
                { required: true, message: 'Please input your username!' },
              ]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder="Username"
                autoFocus
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[
                { required: true, message: 'Please input your password!' },
              ]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="Password"
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                icon={<LoginOutlined />}
                style={{ width: '100%' }}
              >
                Sign In
              </Button>
            </Form.Item>
          </Form>

          <Divider />

          {/* Sample Accounts Info */}
          {/*<div style={{ textAlign: 'center' }}>*/}
          {/*  <Text type="secondary" style={{ fontSize: '12px' }}>*/}
          {/*    Sample Accounts:*/}
          {/*  </Text>*/}
          {/*  <br />*/}
          {/*  <Text type="secondary" style={{ fontSize: '11px' }}>*/}
          {/*    Admin: admin / adminpass*/}
          {/*  </Text>*/}
          {/*  <br />*/}
          {/*  <Text type="secondary" style={{ fontSize: '11px' }}>*/}
          {/*    Leader: leader / leaderpass*/}
          {/*  </Text>*/}
          {/*  <br />*/}
          {/*  <Text type="secondary" style={{ fontSize: '11px' }}>*/}
          {/*    Employee: employee / employeepass*/}
          {/*  </Text>*/}
          {/*</div>*/}
        </Space>
      </Card>
    </div>
  );
};

export default Login; 